import { SanityBlogPost, SanityBlogTag } from "typings/graphql"
import { cleanUrlSlashes } from "./stringUtils"

export const getCategory = (post: SanityBlogPost) =>
  post?.primaryCategory.path.current.replace("/", "")

export const blogCatPath = (post: Partial<SanityBlogPost>) =>
  cleanUrlSlashes(
    `/blog/${post?.primaryCategory?.path?.current}/${post?.path?.current}/`
  )

export const blogTagPath = (tag: SanityBlogTag) =>
  cleanUrlSlashes(`/blog/tags/${tag?.path?.current ?? ""}/`)

export const shuffle = (arr: any[]) => {
  return arr
    .map(a => ({ sort: Math.random(), value: a }))
    .sort((a, b) => a.sort - b.sort)
    .map(a => a.value)
}
